import React, { useState } from 'react'
import {
  GridColumnMenuItem,
  GridColumnMenuItemContent,
  GridColumnMenuItemGroup,
  GridColumnMenuProps,
} from '@progress/kendo-react-grid'

import { GridColumn } from './RecordsClients/columns'

interface ICustomColumnMenu extends GridColumnMenuProps {
  columns: GridColumn[]
  onColumnsSubmit: (columns: GridColumn[]) => void
}

export const CustomColumnMenu: React.FC<ICustomColumnMenu> = ({
  columns: initialColumns,
  onColumnsSubmit,
  onCloseMenu,
}) => {
  const [columns, setColumns] = useState<GridColumn[]>(initialColumns)
  const [columnsExpanded, setColumnsExpanded] = useState<boolean>(false)

  const onToggleColumn = (id: number): void => {
    setColumns(
      columns.map((column, idx) => (idx === id ? { ...column, show: !column.show } : column))
    )
  }

  const onReset = (event: React.SyntheticEvent): void => {
    event.preventDefault()
    const allColumns = initialColumns.map((col) => ({ ...col, show: true }))
    setColumns(allColumns)
    onSubmit()
  }

  const onSubmit = (event?: React.SyntheticEvent): void => {
    if (event) event.preventDefault()
    onColumnsSubmit(columns)
    if (onCloseMenu) onCloseMenu()
  }

  const onMenuItemClick = (): void => {
    setColumnsExpanded(!columnsExpanded)
  }

  const oneVisibleColumn = columns.filter((c) => c.show).length === 1

  return (
    <div>
      <GridColumnMenuItemGroup>
        <GridColumnMenuItem title='Columns' iconClass='k-i-columns' onClick={onMenuItemClick} />
        <GridColumnMenuItemContent show={columnsExpanded}>
          <div className='k-column-list-wrapper'>
            <form onSubmit={onSubmit} onReset={onReset}>
              <div className='k-column-list'>
                {columns.map((column, idx) => (
                  <div key={idx} className='k-column-list-item'>
                    <span>
                      <input
                        id={`column-visiblity-show-${idx}`}
                        className='k-checkbox'
                        type='checkbox'
                        readOnly
                        disabled={column.show && oneVisibleColumn}
                        checked={column.show}
                        onClick={() => onToggleColumn(idx)}
                      />
                      <label
                        htmlFor={`column-visiblity-show-${idx}`}
                        className='k-checkbox-label'
                        style={{ userSelect: 'none' }}
                      >
                        {column.title}
                      </label>
                    </span>
                  </div>
                ))}
              </div>
              <div className='k-columnmenu-actions'>
                <button type='reset' className='k-button'>
                  Reset
                </button>
                <button className='k-button k-button-solid-primary'>Save</button>
              </div>
            </form>
          </div>
        </GridColumnMenuItemContent>
      </GridColumnMenuItemGroup>
    </div>
  )
}
